/**
 * Country classification for tax display regimes.
 *
 * Each array determines how prices and tax labels are rendered for that country.
 * To update tax treatment for a country, move its ISO 3166-1 alpha-2 code
 * between arrays — no component changes needed.
 */

/** Show gross price, label "VAT included" */
export const VAT_INCLUDED_COUNTRIES = [
  'ZA',
  'BG',
  'SI',
  'SK',
  'HR',
  'RO',
  'CZ',
  'PL',
  'HU',
  'BH',
  'JO',
  'SA',
  'AE',
  'TH',
  'MY',
  'TW',
  'SG',
  'AT',
  'BE',
  'DK',
  'FI',
  'FR',
  'DE',
  'IT',
  'GR',
  'LU',
  'NO',
  'PT',
  'NL',
  'ES',
  'SE',
  'CH',
  'GB',
  'AL',
  'DZ',
  'AD',
  'AO',
  'AG',
  'AR',
  'AM',
  'AW',
  'AZ',
  'BS',
  'BB',
  'BZ',
  'BM',
  'BY',
  'BA',
  'BR',
  'VG',
  'BN',
  'KH',
  'KY',
  'CL',
  'CO',
  'DM',
  'CR',
  'CW',
  'CY',
  'DO',
  'EG',
  'EE',
  'FJ',
  'GE',
  'GH',
  'GI',
  'GT',
  'HN',
  'IS',
  'IN',
  'ID',
  'IQ',
  'IR',
  'IL',
  'CI',
  'JM',
  'KZ',
  'KE',
  'KG',
  'LA',
  'LV',
  'LB',
  'LI',
  'LT',
  'MO',
  'MK',
  'MG',
  'MV',
  'MT',
  'MP',
  'MU',
  'MX',
  'MD',
  'MC',
  'ME',
  'MA',
  'MM',
  'NA',
  'NP',
  'NC',
  'NZ',
  'NG',
  'OM',
  'PK',
  'PA',
  'PY',
  'PE',
  'PH',
  'PR',
  'CG',
  'IE',
  'RE',
  'RU',
  'BL',
  'KN',
  'LC',
  'RS',
  'SC',
  'KR',
  'LK',
  'SX',
  'MF',
  'TJ',
  'TN',
  'TR',
  'TM',
  'TC',
  'UA',
  'UY',
  'VI',
  'UZ',
  'VE',
  'VN',
] as const;

/** Show gross price, label "Incl. GST" */
export const GST_INCLUDED_COUNTRIES = ['AU'] as const;

/** Show gross price, label "Consumption Tax Included" */
export const CONSUMPTION_TAX_INCLUDED_COUNTRIES = ['JP'] as const;

/** Show net price, label "Excl. Sales Tax" (switches to "Incl." once tax is calculated) */
export const TAX_EXCLUDED_COUNTRIES = ['US', 'CA'] as const;

/** Show gross price, no tax label, hide the tax line entirely */
export const NO_TAX_COUNTRIES = ['HK', 'KW', 'QA'] as const;
